module.exports = __webpack_public_path__ + "static/platform-psn-bea2e530b8c9ac4449fb13ccd662d89e.png";